import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { QRCodeCanvas } from 'qrcode.react';
import { Subtitles, pubnub, TextToSpeech, SpeechToText, MainWrapper, Select } from 'wwtc-sdk';
import {
    endpointSpeechToText,
    endpointTextToSpeech,
    endpointTranslate,
    endpointDetectLanguage,
    signedEndpoint,
} from '../constants/connection';
import specialLanguages from '../constants/specialLanguages';
import { Download, Times, Users, User, LanguageDetection, Share } from './svg/icons';
import buildSubtitlesFile from '../utils/subtitles';
import { handlePreRequestSubtitles } from './utils';

function Main() {
    // This values come from Login components
    // Also could set up constants values
    // This values are required like props of the MainWrapper
    const history = useHistory();
    const [modalParticipants, setModalParticipants] = useState(false);
    const [modalJoinRoom, setModalJoinRoom] = useState({
        visible: false,
        participantId: null,
        participantName: null,
    });
    const [modalLanguageDetection, setModalLanguageDetection] = useState(false);
    const [modalClipboard, setModalClipboard] = useState(false);
    const activeLanguageDetection = window.activeLanguageDetection;

    const {
        userName,
        language,
        gender,
        roomName,
        apiToken,
        logoHeader,
        languagesPreTranslate,
        languages,
    } = history.location.state || {
        userName: '',
        language: '',
        gender: '',
        roomName: 'default', // default name
        apiToken: null,
        logoHeader: null,
        languagesPreTranslate: null,
        languages: [],
    };

    useEffect(() => {
        if (userName === '') {
            history.push(`/`, {
                userName: userName,
                language: language,
                gender: gender,
            });
        }
        pubnub.setState({
            state: { role: 'moderator' },
            channels: [roomName],
        });

        pubnub.addListener({
            signal: function (s) {
                if (s.message.search('request_room') >= 0) {
                    const infoParsed = s.message.split('request_room-')[1];
                    const participantId = infoParsed.split('_')[0];
                    const participantName = infoParsed.split('_')[1];
                    setModalJoinRoom({ visible: true, id: participantId, name: participantName });
                }
            },
        });
    }, []);

    return (
        <MainWrapper
            autologin={false}
            gender={gender}
            language={language}
            roomName={roomName}
            userName={userName}
            languages={languages}
        >
            <Header
                logoHeader={logoHeader}
                pubnub={pubnub}
                roomName={roomName}
                setModalParticipants={setModalParticipants}
                setModalLanguageDetection={setModalLanguageDetection}
                setModalClipboard={setModalClipboard}
                activeLanguageDetection={activeLanguageDetection}
            />
            <WrapperComponents
                apiToken={apiToken}
                setModalParticipants={setModalParticipants}
                modalParticipants={modalParticipants}
                setModalJoinRoom={setModalJoinRoom}
                modalJoinRoom={modalJoinRoom}
                setModalLanguageDetection={setModalLanguageDetection}
                modalLanguageDetection={modalLanguageDetection}
                modalClipboard={modalClipboard}
                setModalClipboard={setModalClipboard}
                languagesPreTranslate={languagesPreTranslate}
                languages={languages}
            />
        </MainWrapper>
    );
}

function Header(props) {
    // initName comes from autologin component
    const {
        logoHeader,
        pubnub,
        initName,
        roomName,
        setModalParticipants,
        setModalLanguageDetection,
        setModalClipboard,
        activeLanguageDetection,
    } = props;

    const handleLogout = async () => {
        if (pubnub) {
            await pubnub.signal({
                message: 'logout_admin',
                channel: roomName,
            });
            pubnub.unsubscribeAll();
            window.location.replace(window.location.origin);
        } else {
            window.location.replace(window.location.origin);
        }
    };

    return (
        <header>
            <div className="header-left-section">
                <div className="info-user">
                    <img src={`${logoHeader}`} alt="WWTC" />
                </div>
            </div>
            <div className="header-center-section">
                <div className="direct-buttons hidden-mobile">
                    <span>NOW Talk and Text</span>
                </div>
            </div>
            <div className="header-right-section">
                <div className="settings-user">
                    {activeLanguageDetection && (
                        <span
                            className="lang-detection-btn"
                            data-toggle="tooltip"
                            data-placement="bottom"
                            title="Languade Detection"
                            data-container="body"
                            onClick={() => setModalLanguageDetection(true)}
                        >
                            <LanguageDetection />
                        </span>
                    )}
                    &nbsp;
                    <span
                        className="share-btn"
                        data-toggle="tooltip"
                        data-placement="bottom"
                        title="Share room"
                        data-container="body"
                        onClick={() => setModalClipboard(true)}
                    >
                        <Share />
                    </span>
                    &nbsp;
                    <span className="participants-label hidden-mobile">Roll Call</span>
                    &nbsp;
                    <span
                        className="participants-btn"
                        data-toggle="tooltip"
                        data-placement="bottom"
                        title="Participants"
                        data-container="body"
                        onClick={() => setModalParticipants(true)}
                    >
                        <Users />
                    </span>
                    &nbsp;&nbsp;
                    <span className="profile-name hidden-mobile">{initName}</span>
                    &nbsp;&nbsp;
                    <span
                        className="logout-btn"
                        data-toggle="tooltip"
                        data-placement="bottom"
                        title="Logout"
                        data-container="body"
                        onClick={handleLogout}
                    >
                        <i className="fas fa-sign-out-alt"></i>
                    </span>
                </div>
            </div>
        </header>
    );
}

function WrapperComponents(props) {
    // values from login
    const {
        apiToken,
        initName,
        initLanguage,
        initGender,
        conferenceName,
        modalParticipants,
        setModalParticipants,
        modalJoinRoom,
        setModalJoinRoom,
        modalLanguageDetection,
        setModalLanguageDetection,
        modalClipboard,
        setModalClipboard,
        languagesPreTranslate,
        languages,
    } = props;
    const [isBuildingPdf, setIsBuildingPdf] = useState(false);
    const [modalDownload, setModalDownload] = useState(false);
    const [languageDetectionEnabled, setLanguageDetectionEnabled] = useState(false);
    const [valueLanguageDetection, setValueLanguageDetection] = useState(null);
    const canKickParticipants = window.canKickParticipants;

    const isSpecialLanguage = (subtitles) => {
        const specialSubtitle = specialLanguages.find((special) => {
            var regex = new RegExp(special, 'g');
            var atLeastOneMatches = subtitles.some((e) => regex.test(e.speakerLanguage));
            return atLeastOneMatches;
        });

        return !!specialSubtitle;
    };

    const downloadSubtitlesPDF = (subtitles) => {
        setIsBuildingPdf(true);
        const contentPDF = buildSubtitlesFile(subtitles);

        // detect special languages
        const subtitlesWithSpecialLanguages = isSpecialLanguage(subtitles);

        // download unicode typography
        if (subtitlesWithSpecialLanguages) {
            window.pdfMake.fonts = {
                ArialUnicode: {
                    normal: 'https://sdkresources.s3.amazonaws.com/ArialUnicodeMSFont.ttf',
                    bold: 'https://sdkresources.s3.amazonaws.com/ArialUnicodeMSFont.ttf',
                    italics: 'https://sdkresources.s3.amazonaws.com/ArialUnicodeMSFont.ttf',
                },
            };
        }

        var docDefinition = {
            content: contentPDF,
            defaultStyle: {
                font: subtitlesWithSpecialLanguages ? 'ArialUnicode' : 'Roboto',
                fontSize: 12,
            },
        };

        window.pdfMake.createPdf(docDefinition).download(() => {
            setIsBuildingPdf(false);
        });
    };

    const fetchTextToSpeechCustom = async (endpoint, text, sourceLanguage, voice, itemTtsCall) => {
        try {
            let response = await fetch(endpoint.url.replace(/:sourceLanguage/g, sourceLanguage), {
                method: endpoint.method,
                redirect: 'follow',
                body: JSON.stringify({
                    text,
                }),
            });
            let data = await response.json();
            try {
                var arrayBuffer = _base64ToArrayBuffer(data.audio);
                let blob = new Blob([arrayBuffer], { type: 'audio/wav' });
                const downloadUrl = window.webkitURL.createObjectURL(blob);
                return { downloadUrl, indexCall: itemTtsCall };
            } catch (e) {
                return {
                    indexCall: itemTtsCall,
                    error: e,
                };
            }
        } catch (err) {
            return {
                indexCall: itemTtsCall,
                error: err,
            };
        }
    };

    const _base64ToArrayBuffer = (base64) => {
        var binary_string = window.atob(base64);
        var len = binary_string.length;
        var bytes = new Uint8Array(len);
        for (var i = 0; i < len; i++) {
            bytes[i] = binary_string.charCodeAt(i);
        }
        return bytes.buffer;
    };

    const kickOutParticipant = async (participant) => {
        await pubnub.signal({
            message: `kickout_participant-${participant.id}`,
            channel: conferenceName,
        });
    };

    const deleteParticipantsContent = async () => {
        await pubnub.signal({
            message: 'clean_history_content',
            channel: conferenceName,
        });
    };

    const letParticipantJoinRoom = async (participantId) => {
        await pubnub.signal({
            message: `join_room-${participantId}`,
            channel: conferenceName,
        });
    };

    return (
        <div className="wrapper-components">
            <Subtitles.SubtitlesUI
                username={initName}
                initialSourceLanguage={initLanguage}
                initialTargetLanguage={initLanguage}
                initialVisible={true}
                defaultBilingual={false}
                endpoint={signedEndpoint(apiToken, endpointTranslate)}
                provider="pubnub"
                speechRecognition={true}
                showButtonCloseComponent={false}
                showFlipButton={true}
                showSpeedOption={true}
                showLanguageServices={true}
                style={stylesWrapper.fullContainer}
                ttsOption={true}
                channel={conferenceName}
                languagesPreTranslate={languagesPreTranslate}
                render={(subtitles) =>
                    isBuildingPdf ? null : (
                        <button
                            className="a-element"
                            onClick={() => downloadSubtitlesPDF(subtitles)}
                        >
                            <Download />
                        </button>
                    )
                }
                preRequestSubtitles={handlePreRequestSubtitles}
            />
            <SpeechToText.SpeechToTextUI
                username={initName}
                initialLanguage={initLanguage}
                initialVisible={false}
                initialActive={false}
                withUI={false} // to use only speech recognition
                endpoint={signedEndpoint(apiToken, endpointSpeechToText)}
                detectLanguage={languageDetectionEnabled}
                endpointDetectLanguage={signedEndpoint(apiToken, endpointDetectLanguage)}
                paramsDetectLanguage={[initLanguage, valueLanguageDetection?.value]}
            />
            <TextToSpeech.TextToSpeechUI
                initialLanguage={initLanguage}
                initialGender={initGender}
                initialVisible={false}
                initialActive={false}
                withUI={false} // to use only audio player
                endpoint={signedEndpoint(apiToken, endpointTextToSpeech)}
                fetchCustom={fetchTextToSpeechCustom}
            />
            {modalParticipants ? (
                <ModalParticipants
                    closeModal={() => setModalParticipants(false)}
                    pubnub={pubnub}
                    conferenceName={conferenceName}
                    kickOutParticipant={kickOutParticipant}
                    deleteParticipantsContent={deleteParticipantsContent}
                    canKickParticipants={canKickParticipants}
                />
            ) : null}
            {modalJoinRoom.visible ? (
                <ModalJoinRoom
                    closeModal={() => setModalJoinRoom({ ...modalJoinRoom, visible: false })}
                    pubnub={pubnub}
                    conferenceName={conferenceName}
                    letParticipantJoinRoom={letParticipantJoinRoom}
                    modalJoinRoom={modalJoinRoom}
                />
            ) : null}
            {modalLanguageDetection ? (
                <ModalLanguageDetection
                    closeModal={() => setModalLanguageDetection(false)}
                    languages={languages}
                    languageDetectionEnabled={languageDetectionEnabled}
                    setLanguageDetectionEnabled={setLanguageDetectionEnabled}
                    valueLanguageDetection={valueLanguageDetection}
                    setValueLanguageDetection={setValueLanguageDetection}
                />
            ) : null}
            {modalClipboard ? (
                <ModalClipboard
                    closeModal={() => setModalClipboard(false)}
                    pubnub={pubnub}
                    conferenceName={conferenceName}
                />
            ) : null}
            {isBuildingPdf ? <ModalDownload onCloseModal={() => setModalDownload(false)} /> : null}
        </div>
    );
}

const ModalDownload = ({ onCloseModal }) => {
    return (
        <div style={stylesWrapper.containerModal}>
            <div style={{ ...stylesWrapper.wrapperModal, height: 180, width: 450 }}>
                <div className="header-container">
                    <div className="header-title">
                        <span>PDF Subtitles</span>
                    </div>
                    <div className="header-options"></div>
                </div>
                <div
                    className="body-container"
                    style={{ ...stylesWrapper.bodyModal, textAlign: 'center' }}
                >
                    <p>Downloading PDF file...</p>
                    <p style={{ fontSize: 14 }}>Please wait, this could take a few seconds.</p>
                </div>
            </div>
        </div>
    );
};

const ModalParticipants = (props) => {
    const {
        closeModal,
        pubnub,
        conferenceName,
        kickOutParticipant,
        deleteParticipantsContent,
        canKickParticipants,
    } = props;
    const [participants, setParticipants] = useState([]);
    const myPubnubId = pubnub.userId;

    useEffect(() => {
        pubnub
            .hereNow({
                channels: [conferenceName],
                includeState: true,
            })
            .then(async (res) => {
                let participants = [];
                const participantsInChannel = res.channels[conferenceName].occupants;

                for (let index = 0; index < participantsInChannel.length; index++) {
                    const item = participantsInChannel[index];

                    try {
                        const { data } = await pubnub.objects.getUUIDMetadata({
                            uuid: item.uuid,
                        });
                        participants.push(data);
                    } catch (e) {
                        console.log(e);
                    }
                }
                setParticipants(participants);
            });
    }, []);

    const handleParticipantKickOut = (participant) => {
        kickOutParticipant(participant);
        const filteredParticipants = participants.filter((e) => e.id !== participant.id);

        setParticipants(filteredParticipants);
    };

    const downloadParticipants = () => {
        var contentPDF = [];
        contentPDF.push({
            text: `${conferenceName} - Roll Call`,
            style: 'header',
            bold: true,
        });
        participants.forEach((item, index) => {
            contentPDF.push({
                ul: [{ text: item.name, bold: false }],
            });
        });

        var docDefinition = {
            content: contentPDF,
            defaultStyle: {
                fontSize: 12,
            },
        };
        window.pdfMake.createPdf(docDefinition).download('rollCallWWTC.pdf');
    };

    return (
        <div style={stylesWrapper.containerModal}>
            <div style={stylesWrapper.wrapperModal}>
                <div className="header-container">
                    <div className="header-title">
                        <span>Roll Call</span>
                    </div>
                    <div className="header-options">
                        <button className="a-element" onClick={downloadParticipants}>
                            <Download />
                        </button>
                        <button className="a-element" onClick={closeModal}>
                            <Times />
                        </button>
                    </div>
                </div>
                <div className="body-container" style={stylesWrapper.bodyModal}>
                    {participants.map((item, index) => {
                        return (
                            <div
                                key={index}
                                style={stylesWrapper.participantItem}
                                className="participant-item"
                            >
                                <div style={stylesWrapper.descriptionParticipant}>
                                    <span>
                                        <User />
                                    </span>
                                    &nbsp;&nbsp;
                                    <p style={{ margin: 0, textIndent: 0 }}>
                                        {item.name}
                                        {myPubnubId === item.id ? ' (You)' : null}
                                    </p>
                                </div>
                                <div>
                                    {myPubnubId !== item.id && canKickParticipants ? (
                                        <button
                                            className="a-element"
                                            onClick={() => handleParticipantKickOut(item)}
                                        >
                                            <Times />
                                        </button>
                                    ) : null}
                                </div>
                            </div>
                        );
                    })}
                </div>
                <hr />
                <div
                    className="footer-container d-flex justify-content-center align-items-center"
                    styles={stylesWrapper.footerModal}
                >
                    <button
                        className=" btn btn-success btn-sm"
                        disabled={participants.length === 1}
                        onClick={deleteParticipantsContent}
                    >
                        Delete participants content
                    </button>
                </div>
            </div>
        </div>
    );
};

const ModalJoinRoom = (props) => {
    const { closeModal, modalJoinRoom, letParticipantJoinRoom } = props;
    const { id, name } = modalJoinRoom;

    const handleJoinRoom = () => {
        letParticipantJoinRoom(id);
        closeModal();
    };

    return (
        <div style={stylesWrapper.containerModal}>
            <div style={{ ...stylesWrapper.wrapperModal, height: 200 }}>
                <div className="header-container">
                    <div className="header-title">
                        <span>Join participant</span>
                    </div>
                    <div className="header-options">
                        <button className="a-element" onClick={closeModal}>
                            <Times />
                        </button>
                    </div>
                </div>
                <div className="body-container text-center" style={stylesWrapper.bodyModal}>
                    <p>
                        {' '}
                        <strong>{name}</strong> would like to join in the room
                    </p>
                </div>
                <div
                    className="footer-container d-flex justify-content-center align-items-center"
                    styles={stylesWrapper.footerModal}
                >
                    <button className="btn btn-primary" onClick={handleJoinRoom}>
                        Admit to Session
                    </button>
                </div>
            </div>
        </div>
    );
};

const ModalLanguageDetection = (props) => {
    const {
        closeModal,
        languages,
        languageDetectionEnabled,
        setLanguageDetectionEnabled,
        valueLanguageDetection,
        setValueLanguageDetection,
    } = props;

    const handleOkModal = () => {
        if (!!languageDetectionEnabled && !valueLanguageDetection) {
            alert('Please, select your secondary language');
            return;
        }

        if (!languageDetectionEnabled) {
            setValueLanguageDetection(null);
            closeModal();
        }

        if (!!languageDetectionEnabled && !!valueLanguageDetection) {
            closeModal();
        }
    };

    const handleCloseModal = () => {
        if (!!languageDetectionEnabled && !valueLanguageDetection) {
            setValueLanguageDetection(null);
            setLanguageDetectionEnabled(false);
            closeModal();
            return;
        }

        if (!languageDetectionEnabled) {
            setValueLanguageDetection(null);
            closeModal();
        }

        if (!!languageDetectionEnabled && !!valueLanguageDetection) {
            closeModal();
        }
    };

    return (
        <div style={stylesWrapper.containerModal}>
            <div style={{ ...stylesWrapper.wrapperModal, height: 250 }}>
                <div className="header-container">
                    <div className="header-title">
                        <span style={{ fontSize: 14 }}>Language Detection</span>
                    </div>
                    <div className="header-options">
                        <button className="a-element" onClick={handleCloseModal}>
                            <Times />
                        </button>
                    </div>
                </div>
                <div className="body-container" style={stylesWrapper.bodyModal}>
                    <br />
                    <div
                        style={{
                            display: 'flex',
                            justifyContent: 'space-evenly',
                            alignItems: 'center',
                        }}
                    >
                        <div>
                            <input
                                type="radio"
                                id="disabled"
                                name="languageDetectionEnabled"
                                value="disabled"
                                checked={languageDetectionEnabled === false}
                                onChange={(e) => setLanguageDetectionEnabled(false)}
                            />
                            <label htmlFor="disabled" style={{ fontSize: 14 }}>
                                Disabled
                            </label>
                        </div>

                        <div>
                            <input
                                type="radio"
                                id="enabled"
                                name="languageDetectionEnabled"
                                value="enabled"
                                checked={languageDetectionEnabled === true}
                                onChange={(e) => setLanguageDetectionEnabled(true)}
                            />
                            <label htmlFor="enabled" style={{ fontSize: 14 }}>
                                Enabled
                            </label>
                        </div>
                    </div>
                    <br />
                    {languageDetectionEnabled && (
                        <div>
                            <p style={{ fontSize: 14 }}>Select your secondary language</p>
                            <Select
                                handleChange={(lng) => setValueLanguageDetection(lng)}
                                placeholder="Select language"
                                data={languages}
                                value={valueLanguageDetection || ''}
                                showLanguageServices={true}
                                styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
                            />
                        </div>
                    )}
                </div>
                <hr />
                <div
                    className="footer-container d-flex justify-content-center align-items-center"
                    styles={stylesWrapper.footerModal}
                >
                    <button onClick={handleOkModal} className="btn btn-success btn-sm">
                        Ok
                    </button>
                </div>
            </div>
        </div>
    );
};

const ModalClipboard = (props) => {
    const { closeModal, pubnub } = props;
    const [isCopied, setIsCopied] = useState(false);
    const [isQrCopied, setIsQrCopied] = useState(false);

    const buildInvitationLink = () => {
        const baseUrl = window.location.href.split('/moderator')[0];
        const hostId = pubnub.getUUID();
        const url = `${baseUrl}/input`;
        return url;
    };

    const copyLinkToClipboard = () => {
        // Create a "hidden" input
        var aux = document.createElement('input');
        var url = buildInvitationLink();

        // Assign it the value of the specified element
        aux.setAttribute('value', url);

        // Append it to the body
        document.body.appendChild(aux);

        // Highlight its content
        aux.select();

        // Copy the highlighted text
        document.execCommand('copy');

        // Remove it from the body
        document.body.removeChild(aux);

        setIsCopied(true);
        setTimeout(() => setIsCopied(false), 2000);
    };

    const copyQrToClipboard = (elementId) => {
        const canvas = document.getElementById(elementId);
        if (canvas) {
            canvas.toBlob(function (blob) {
                const item = new ClipboardItem({ 'image/png': blob });
                navigator.clipboard.write([item]);
                setIsQrCopied(true);
                setTimeout(() => setIsQrCopied(false), 2000);
            });
        }
    };

    const link = buildInvitationLink();

    return (
        <div style={stylesWrapper.containerModal}>
            <div style={{ ...stylesWrapper.wrapperModal, height: 350, width: 450 }}>
                <div className="header-container">
                    <div className="header-title">
                        <span>Share room</span>
                    </div>
                    <div className="header-options">
                        <button className="a-element" onClick={closeModal}>
                            <Times />
                        </button>
                    </div>
                </div>
                <div
                    className="body-container"
                    style={{ ...stylesWrapper.bodyModalInvite, textAlign: 'center' }}
                >
                    <p>Share this room with your participants</p>
                    <div style={{ marginTop: 20 }}>
                        <QRCodeCanvas value={link} size={128} id="canvas-share-room" />
                    </div>
                    <div
                        style={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            gap: '10px',
                            marginTop: 20,
                        }}
                    >
                        <button
                            type="button"
                            className="Button  Button-primary"
                            style={{ textTransform: 'capitalize' }}
                            onClick={copyLinkToClipboard}
                        >
                            {isCopied ? 'Link Copied!' : 'Copy Link'}
                        </button>
                        <button
                            type="button"
                            className="Button  Button-secondary"
                            style={{ textTransform: 'capitalize' }}
                            onClick={() => copyQrToClipboard('canvas-share-room')}
                        >
                            {isQrCopied ? 'QR Copied!' : 'Copy QR'}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

const stylesWrapper = {
    fullSubtitlesContainer: {
        width: 'calc(100% - 10px)',
        height: 'calc(100% - 10px)',
        margin: '5px auto',
        position: 'relative',
        zIndex: 20,
    },
    subtitlesContainer: {
        width: 'calc(100% - 10px)',
        height: 'calc(50% - 10px)',
        margin: '5px auto',
    },
    chatContainer: {
        width: 'calc(100% - 10px)',
        height: 'calc(50% - 10px)',
        margin: '5px auto',
    },
    containerModal: {
        display: 'flex',
        justifyContent: 'center',
        height: 'calc(100vh - 50px)',
        width: '100vw',
        background: 'rgba(1,1,1,0.3)',
        position: 'absolute',
        left: 0,
        top: 0,
        zIndex: 2000,
    },
    bodyModal: {
        marginTop: 24,
        height: 'calc(100% - 90px)',
        overflow: 'auto',
    },
    bodyModalInvite: {
        marginTop: 24,
        height: 'calc(100% - 30px)',
        overflow: 'auto',
    },
    footerModal: {},
    wrapperModal: {
        padding: '10px',
        backgroundColor: 'white',
        borderRadius: 5,
        height: 500,
        top: 'calc(50% - 250px)',
        width: 320,
        position: 'absolute',
        WebkitBoxShadow: '4px 4px 9px -1px rgba(0,0,0,0.75)',
        MozBoxShadow: '4px 4px 9px -1px rgba(0,0,0,0.75)',
        boxShadow: '4px 4px 9px -1px rgba(0,0,0,0.75)',
    },
    participantItem: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '12px 1em',
        cursor: 'default',
    },
    descriptionParticipant: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    fullContainer: {
        width: 'calc(100% - 20px)',
        height: '100%',
        margin: '10px auto',
    },
};

export default Main;
